module.exports = __webpack_public_path__ + "img/Lock.3e254c52.svg";